import React from 'react';
import { Button } from '@material-ui/core';
import { toJS } from 'mobx';
import { useRootStore } from '../../../../stores/BridgeProvider';
import DealForm from '../../../deal/DealForm';

const DealModal = ({ dealId, handleClose }) => {
  const { dealMapperStore } = useRootStore();
  const deal = dealId ? dealMapperStore.deal(dealId) : {};

  console.log(toJS(deal));
  const { Pending } = deal;

  return (
    <DealForm
      submitLabel="Submit"
      deal={deal}
      onSubmit={async values => {
        const {
          DealId,
          DealNumber,
          Title,
          Description,
          ContractDate,
          TransactionDate,
          BillableDate,
          PayableDate,
          AgentContactId,
          ApprovedBy,
          StatusId,
        } = values;
        if (DealId) {
          dealMapperStore.updateDeal({
            ...deal,
            DealId,
            DealNumber,
            Title,
            Description,
            ContractDate,
            TransactionDate,
            BillableDate,
            PayableDate,
            AgentContactId,
            ApprovedBy,
            StatusId,
          });
        } else {
          dealMapperStore.addDeal({
            Title,
            DealNumber,
            Description,
            ContractDate,
            TransactionDate,
            BillableDate,
            PayableDate,
            AgentContactId,
            ApprovedBy,
            StatusId,
          });
        }
        handleClose();
      }}
      buttons={[
        <Button
          key={3}
          color="secondary"
          variant="outlined"
          size="large"
          onClick={handleClose}
        >
          Cancel
        </Button>,
      ]}
    />
  );
};

export default DealModal;
